import React from "react";
import TestimonialCard from "./TestimonialCard";
import { TESTIMONIAL_DETAIL } from "../utils/constants";

const Testimonials = () => {
	return (
		<>
			<h1 className="font-bold w-full text-center text-3xl mb-5">
				Testimonials
			</h1>
			<div className="px-10 mb-4 flex gap-10 flex-col md:flex-row">
				{TESTIMONIAL_DETAIL.map((testimonial, index) => (
					<TestimonialCard key={index} testimonial={testimonial} />
				))}
			</div>
		</>
	);
};

export default Testimonials;
